import Markdoc from "@markdoc/markdoc";

export const stepsHeading = {
  selfClosing: true,
  transform() {
    return new Markdoc.Tag("h3", {}, ["Steps"]);
  },
};
